import { Component } from '@angular/core';

@Component({
    selector: 'app-daily-review',
    templateUrl: './daily-review.component.html',
    styleUrls: ['./daily-review.component.scss'],
})
export class DailyReviewComponent {}
